import React from 'react';
export function Footer() {
  return <footer className="bg-card-bg border-t border-[rgba(107,0,182,0.3)] py-[30px] px-5 text-center" data-id="element-47" data-mp="32wd2qgad7ltj">
      <p className="text-[0.8rem] text-white/35 leading-[1.8]" data-id="element-48" data-mp="3ggk6ap6ov1ww">
        © 2025 Dr. Eduardo Ortiz — PLEASURE, GUILT AND EMPTINESS · The Path to
        Recovery
        <br data-id="element-49" data-mp="36oo9rik93jus" />
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-50" data-mp="36qhdaozkhnyk">
          Terms and conditions
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-51" data-mp="37o74x94c1ef">
          Privacy policy
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-52" data-mp="3qcnjqr6zqmz5">
          Contact
        </a>
      </p>
    </footer>;
}